// @ts-nocheck
import { name2num, num2name, } from "../../(Subscription)/SubscriptionStatus";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../../../../runtime/json/scalar";
import { WireType, } from "../../../../../../../runtime/wire/index";
import { default as serialize, } from "../../../../../../../runtime/wire/serialize";
import { default as Long, } from "../../../../../../../runtime/Long";
import { default as deserialize, } from "../../../../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        previousStatus: "SUBSCRIPTION_STATUS_UNSPECIFIED",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.previousStatus !== undefined)
        result.previousStatus = tsValueToJsonValueFns.enum(value.previousStatus);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.previousStatus !== undefined)
        result.previousStatus = jsonValueToTsValueFns.enum(value.previousStatus);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.previousStatus !== undefined) {
        const tsValue = value.previousStatus;
        result.push([1, { type: WireType.Varint, value: new Long(name2num[tsValue]) }]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.Varint ? num2name[wireValue.value[0]] : undefined;
        if (value === undefined)
            break field;
        result.previousStatus = value;
    }
    return result;
}
